<template>
	<sf-data-table
		ref="Table"
		paging
		:pageUnit="groups.pageUnit"
		:totalSize="groups.totalSize"
		:columns="Cols"
		:rows="rows"
		:excel="isButton_(scrId, 'EX')"
		:stripe="false"
		selection
		:customExcel="excelFunc"
		@changedPage="changedPage"
		creatable
	>
		<template v-slot:customRows="slotProps">
			<template v-if="slotProps.column.property === 'commCd'">
				<template v-if="slotProps.row.rowType && slotProps.row.rowType === 'add'">
					<el-input :value="slotProps.row[slotProps.column.property]" @input="val => onChange(val, slotProps)" />
				</template>
				<template v-else>
					{{ slotProps.row[slotProps.column.property] }}
				</template>
			</template>

			<!--commCdSeq-->
			<template v-if="slotProps.column.property === 'commCdSeq'">
				<div class="position-relative h-100">
					<el-input class="pr-2" :value="slotProps.row[slotProps.column.property]" @input="val => onChange(val, slotProps)"> </el-input>
				</div>
			</template>

			<!--useYn 사용여부-->
			<template v-if="slotProps.column.property === 'useYn'">
				<!-- <template v-if="slotProps.row.userYnflg == 'true'"> -->
				<div class="position-relative h-100">
					<el-select v-model="slotProps.row[slotProps.column.property]" filterable :placeholder="getMessage_('QWCC001163')">
						<el-option v-for="option in useYnList" :key="option.value" :label="option.label" :value="option.value"> </el-option>
					</el-select>
				</div>
				<!-- </template>
				<template v-else>
					{{ slotProps.row.useYn }}
				</template> -->
			</template>
		</template>

		<template v-slot:actionsLeft>
			<!--추가 운영계 반영시 플어야됨.-->
			<sf-button v-if="isButton_(scrId, 'AD')" line icon="square-plue" :onClick="addAction">
				{{ getMessage_('SWCC000007') }}
			</sf-button>
			<!--저장 운영계 반영시 풀어야됨-->
			<sf-button v-if="isButton_(scrId, 'CU')" line icon="file" :onClick="saveAction">
				{{ getMessage_('SWCC000327') }}
			</sf-button>
		</template>
		<template v-slot:actionsRight>
			<!--엑셀업로드-->
			<!-- <sf-button v-if="isButton_(scrId, 'EX')" line icon="excel" :onClick="openModal">
				{{ getMessage_('QWCC000927') }}
			</sf-button> -->
			<!--엑셀템플릿 다운-->
			<sf-button v-if="isButton_(scrId, 'EX')" line icon="excel" hidden :onClick="downExcelTemp">
				{{ getMessage_('QWCC001799') }}
			</sf-button>
		</template>
	</sf-data-table>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@/views/qms/comm/qmsbase/OpCdMng/store/helpers';
import SelectCombo from '@qms/Components/SelectCombo';
import * as yup from 'yup';

/*엑셀다운로드 시작*/
import utils from '@/utils';
import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import { BASE_URL } from '@/constants';
/*엑셀다운로드 끝*/

import _ from 'lodash';
import { number } from 'yup/lib/locale';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			addRowData: {
				rowType: 'add',
				commCd: '', //코드
				commCdName: '', //코드명
				commCdDesc: '', //코드내용
				commCdSeq: '', //순서
				useYn: 'Y', //사용여부
				codeCnNm: '', //코드명(중국어)
				codeKrNm: '', //코드명(한국어)
				codeEnNm: '' //코드명(영어)
			},
			searchStye: {
				//그리드 버튼 스타일 지정
				top: '8px',
				right: '7px'
			},
			selGridRowIndex: ''
		};
	},
	components: {
		//SelectCombo
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.gridList;
		},
		Cols() {
			return [
				{
					label: '* ' + this.getMessage_('QWCC001968'), //코드
					prop: 'commCd',
					width: '150px',
					align: 'center',
					custom: true
				},
				// {
				// 	label: this.getMessage_('SWCC000337'), // 메세지 ID
				// 	prop: 'commCdNameLangId',
				// 	width: '80px',
				// 	sortable: false,
				// 	form: {
				// 		type: 'select',
				// 		options: this.msgIdList,
				// 		isDisabled: this.isDisabled
				// 		// SWCC000355
				// 	}
				// },
				{
					label: this.getMessage_('SWCC000151') + '(' + this.getMessage_('SWCC000463') + ')', // 코드명(중국어)
					prop: 'commCdName',
					width: '300px',
					headerAlign: 'center',
					form: {
						type: 'input',
						maxLength: 30
					}
				},
				// { 중국어 : codeCnNm
				// 	label: this.getMessage_('SWCC000151'), // 코드명
				// 	prop: 'commCdName',
				// 	width: '80px'
				// },
				{
					label: this.getMessage_('SWCC000151') + '(' + this.getMessage_('SWCC000462') + ')', // 코드명(한국)
					prop: 'codeKrNm',
					width: '300px',
					headerAlign: 'center',
					form: {
						type: 'input',
						maxLength: 30
					}
				},
				{
					label: this.getMessage_('SWCC000151') + '(' + this.getMessage_('SWCC000464') + ')', // 코드명(영어)
					prop: 'codeEnNm',
					width: '300px',
					headerAlign: 'center',
					form: {
						type: 'input',
						maxLength: 30
					}
				},
				{
					label: '* ' + this.getMessage_('SWCC000373'), // 순서
					prop: 'commCdSeq',
					width: '100px',
					align: 'center',
					sortable: false,
					custom: true
				},
				{
					label: '* ' + this.getMessage_('SWCC000891'), // 사용여부
					prop: 'useYn',
					width: '100px',
					align: 'center',
					custom: true
				},
				{
					label: '* ' + this.getMessage_('SWCC000152'), // 코드내용
					prop: 'commCdDesc',
					minWidth: '500px',
					align: 'center',
					form: {
						type: 'input',
						maxLength: 300
					}
				}
			];
		},
		ExcelCols() {
			return [
				{
					label: '* ' + this.getMessage_('QWCC001968'), //코드
					prop: 'commCd',
					width: '70px',
					custom: true
				},
				{
					label: this.getMessage_('SWCC000151') + '(' + this.getMessage_('SWCC000463') + ')', // 코드명(중국어)
					prop: 'commCdName',
					width: '100px',
					form: {
						type: 'input',
						maxLength: 30
					}
				},
				{
					label: this.getMessage_('SWCC000151') + '(' + this.getMessage_('SWCC000462') + ')', // 코드명(한국)
					prop: 'codeKrNm',
					width: '100px',
					form: {
						type: 'input',
						maxLength: 30
					}
				},
				{
					label: this.getMessage_('SWCC000151') + '(' + this.getMessage_('SWCC000464') + ')', // 코드명(영어)
					prop: 'codeEnNm',
					width: '100px',
					form: {
						type: 'input',
						maxLength: 30
					}
				},
				{
					label: '* ' + this.getMessage_('SWCC000373'), // 순서
					prop: 'commCdSeq',
					width: '40px',
					align: 'center',
					sortable: false,
					custom: true
				},
				{
					label: '* ' + this.getMessage_('SWCC000891'), // 사용여부
					prop: 'useYn',
					width: '50px',
					align: 'center',
					custom: true
				},
				{
					label: '* ' + this.getMessage_('SWCC000152'), // 코드내용
					prop: 'commCdDesc',
					width: '200px',
					form: {
						type: 'input',
						maxLength: 300
					}
				}
			];
		},
		insVali() {
			return yup.object().shape({
				commCd: yup //코드
					.string()
					.trim()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001968')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001968')])),
				commCdName: yup //코드명
					.string()
					.trim()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('SWCC000151')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('SWCC000151')])),
				commCdDesc: yup //코드내용
					.string()
					.trim()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('SWCC000152')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('SWCC000152')])),
				commCdSeq: yup //순서
					.string()
					.trim()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('SWCC000373')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('SWCC000373')])),
				useYn: yup //사용여부
					.string()
					.trim()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('SWCC000891')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('SWCC000891')])),
				codeKrNm: yup //코드명(한국)
					.string()
					.trim()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('SWCC000462')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('SWCC000462')])),
				codeEnNm: yup //코드명(영어)
					.string()
					.trim()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('SWCC000464')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('SWCC000464')]))
			});
		}
	},
	methods: {
		...serviceMethods,
		...utils, //커스텀 엑셀다운로드시
		onChange(value, slotProps) {
			const key = slotProps.column.property;
			if (key === 'commCd') {
				const regEx = /[^A-Za-z0-9]/g; //숫자와 영문자(대문자)만 가능
				value = value.replace(regEx, '');
				value = value?.length > 10 ? value.slice(0, 10) : value;
			} else if (key === 'commCdSeq') {
				value = value.replace(/[^0-9]/g, '');
				if (value.length > 6) {
					value = value.slice(0, 6);
				}
			}
			slotProps.row[key] = value;
		},

		excelFunc() {
			//커스텀 엑셀다운로드시 필요한 함수
			let queryStr = '';

			queryStr = objectToQuerystring({
				opCd: this.searchParams.opCd,
				useYn: this.searchParams.useYn
			});

			const url = `${BASE_URL}/comm/qmsbase/opCdMng/v1/opCdMng/excel` + queryStr;

			const params = { url, columns: this.ExcelCols };
			this.xlsxDown(params).catch(error => {
				this.$sf_toast({ type: 'error', message: error.message });
			});
		},
		downExcelTemp() {
			let params = {
				apiGubun: 'OP_CD_MNG'
			};

			this.excelTempDown_(params)
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message || this.getMessage_('QWCC001920') //권한이 없거나 다운로드 할 수 없습니다.
					});
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		addAction() {
			//행추가
			let addRowData = { ...this.addRowData };

			this.rows.unshift(addRowData);

			this.$refs.Table.getTable().toggleRowSelection(addRowData);
		},
		getSelectedRows() {
			const defaultObj = this.insVali.cast();
			const rows = this.$refs.asPartInfoTable
				.getSelectedRows()
				.map(row => _(row).omitBy(_.isNull).omitBy(_.isUndefined).defaults(defaultObj).value());
			return rows;
		},
		saveAction() {
			const selected = this.$refs.Table.getSelectedRows();

			if (selected.length < 1) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('SWCC000103'),
					message: this.getMessage_('QWCC000914')
				}); //행을 선택해 주세요. / 수정된 데이터가 없습니다.
				return;
			}
			//벨리데이션체크
			try {
				for (let i = 0; i < selected.length; i++) {
					this.insVali.validateSync(selected[i]);
				}
				//컨펌창
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('SWCC000501'), //저장하시겠습니까?
					buttons: [{ title: this.getMessage_('SWCC000278'), clickFn: this.save }] //저장
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		async save() {
			this.$sf_toggleLoading(true);

			try {
				let selected = this.$refs.Table.getSelectedRows();

				const { code, messageCd } = await this.saveOpCdMng_(selected);

				if (code === 0 || code === 3) {
					this.$sf_toast({
						type: code === 0 ? 'ok' : 'error',
						message: this.getMessage_(messageCd)
					});
					code === 0 && this.$emit('Refresh');
				}
				//Table();
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		resetTable() {
			this.$emit('Refresh');
		},
		isDisabled({ row }) {
			if (row.rowType && row.rowType === 'add') return false;
			else return true;
		},
		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회햇기 때문에 중복 조회 하지 않도록 처리
				// return;
			}
			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });
			this.$emit('Refresh', currentPageVal, pageUnitVal);
		}
	}
};
</script>

<style></style>
